import { format, getISODay } from 'date-fns'

import { DATE_API_DATA_FORMAT_SHORT } from '../../constants/date'
import { toUkTimezoneDate } from '../../utils/date'

import {
  APPOINTMENT_MOCK_DAY_LOAD_LIMIT,
  APPOINTMENT_MOCK_DAY_LOAD_REGULAR_COUNT,
  APPOINTMENT_MOCK_DAY_LOAD_WEEKDAY_COUNTS,
} from './Appointment.constants'

// The same weekdays as the day-load mock of the request date pickers: every Wednesday is full
export function getAppointmentMockDayLoadAdvisory({ date, timezone }) {
  const day = toUkTimezoneDate(date, timezone)

  const followUpCount =
    APPOINTMENT_MOCK_DAY_LOAD_WEEKDAY_COUNTS[getISODay(day)] ??
    APPOINTMENT_MOCK_DAY_LOAD_REGULAR_COUNT

  return {
    date: format(day, DATE_API_DATA_FORMAT_SHORT),
    follow_up_count: followUpCount,
    is_full: followUpCount >= APPOINTMENT_MOCK_DAY_LOAD_LIMIT,
    limit: APPOINTMENT_MOCK_DAY_LOAD_LIMIT,
  }
}
